export default __webpack_public_path__ + "static/googlereviewscolor-9780eb4dfb0822f12cd9475a80f51f48.svg";